import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  EnrichmentRequest,
  EnrichmentResponse,
  HttpResponse,
} from "@/types";

export function useEnrichProfile() {
  return useMutation({
    mutationFn: async ({
      candidacyId,
      currentCompanyId,
      currentJobId,
      enrichmentRequest,
    }: {
      candidacyId: string;
      currentCompanyId: string;
      currentJobId: string;
      enrichmentRequest: EnrichmentRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/enrichment`;
      const res = await guacHttpClient.post<
        EnrichmentResponse,
        HttpResponse<EnrichmentResponse>,
        EnrichmentRequest
      >(path, enrichmentRequest);

      return res.data;
    },
  });
}
